define('responsive-game-feed/app/scripts/views/Social',['require','exports','module','../utils/Tracking','hogan/web/builds/3.0.2/hogan-3.0.2.min.amd','../utils/Utils','Autolinker.js/dist/Autolinker.min','gameday-language/gameday-language','gameday-resource-path/gameday-resource-path'],function(require, exports, module) {

    'use strict';
    
    var tracking = require("../utils/Tracking");
    var hogan = require("hogan/web/builds/3.0.2/hogan-3.0.2.min.amd");
    var Utils = require("../utils/Utils");
    var autoLinker  = require("Autolinker.js/dist/Autolinker.min");
    var gamedayLanguage = require("gameday-language/gameday-language");
    var resourcePath = require("gameday-resource-path/gameday-resource-path");
    
    /**
     * CLASS DESCRIPTION
     *
     * @param NAME {TYPE} PARAM DESCRIPTION
     * @return {TYPE} RETURN DESCRIPTION
     */
    function SocialView(cfg) {
       this.element = cfg.element;
    }

    SocialView.prototype = {

        render: function(cfg) {
               var template = hogan.compile(cfg.template); 
               var model = cfg.model;
               var logostyle = (Utils.options.deviceType === 'ipad') ? "-dark" : "";
               model.data.tweet.user.profile_image_url = model.data.tweet.user.profile_image_url.replace("_normal", "_bigger");
               model.data.tweet.user.teamCode = model.data.tweet.user.screen_name.replace("Gameday", "").toLowerCase();                
               model.data.tweet.user.teamLogo = resourcePath.get("teamLogoCircular",{file_code : model.data.tweet.user.teamCode});
               
               var html = template.render({
                  model : model, 
                  mustacheLanguage : gamedayLanguage(Utils.options.language),
                  linkTweet : Utils.options.link
                });
      
               Utils.insertItem(this.element,model,html);
               var textDiv = $("#"+model.guid).find(".pull-left.gf-tb-container p.tweettext");  
               var retweetedDiv = $("#"+model.guid).find(".pull-left.gf-tb-container p.retweettext");  
               var retweetedDivHtml = retweetedDiv.html();
               var textDivHtml = textDiv.html();
               
               retweetedDiv.html(
                 function(i,html) {
                    return html.replace(/(@\w+)/g, '<span class="handle">$&</span>');
               });
              
               textDiv.html(
                 function(i,html) {
                   return html.replace(/(@\w+)/g, '<span class="handle">$&</span>');
               });

               var links = $("#"+model.guid).find("a");
               
               links.on("click", function(e) {
                
                 if (!Utils.options.deviceType) {  
                   var data = {url: $(this).attr("href")};
                   if(!deviceInteraction.webview(data)){
                     //no handling
                   }
                    return false;
                 } 
                 
                 
               });
               
               $(cfg.feedView).trigger("renderCBTracker_"+cfg.model.guid, cfg.model.guid);
            
         
        }
       
   };    

    return SocialView;

});
